<template>
  <Modal v-model="setAssociationRelationshipModal" :title="$t('key1005705')" width="1000" :transfer="false" :mask-closable="false"
    @on-visible-change="setAssociationRelationshipChange">
    <!--YMSSPU-->
    <div class="flex align-items-center">
      <span class="color-000 font-weight-bold">{{ $t('key1000100') }}</span>
      <span class="color-666">{{ detailsData.name }}</span>
      <span class="color-000 font-weight-bold ml40">{{ configCharacters(false) + 'SPU：' }}</span>
      <span class="color-666">{{ detailsData.ymsSpu }}</span>
    </div>
    <Divider style="margin: 10px 0 15px 0;"/>
    <!--YMSSKU-->
    <div style="max-height: 500px; overflow-y: auto;">
      <div class="mb10" v-for="(item,index) in setAssociationRelationshipData">
        <p class="flex align-items-center mb8">
          <Badge color="#FD5425" class="color-000 font-weight-bold" :text="configCharacters(false) + 'SKU：'"/>
          <span class="color-666">{{ item.ymsSku }}</span>
          <span class="distributorThemeColor ml20">{{ item.specifications }}</span>
        </p>
        <div class="flex flex-wrap">
          <div class="alias_item_box" v-for="(ele, idx) in item.relatedRelationshipsList">
            <!--平台-->
            <div class="flex align-items-center mr40" style="position: relative;">
              <span>{{ $t('key1005444') }}</span>
              <Select v-model.trim="ele.platformId" transfer filterable @on-change="(val) => getPlatformStoreData(index, idx, val)" style="width: 185px;">
                <Option v-for="(talg, ids) in platformList" :key="ids" :value="talg.platformId">{{ talg.name }}</Option>
              </Select>
            </div>
            <!--店铺-->
            <div class="flex align-items-center mr40" style="position: relative;">
              <span>{{ $t('key1005445') }}</span>
              <Select v-model.trim="ele.ymsPlatformAccountId" transfer filterable style="width: 185px;" :disabled="!ele.platformId">
                <Option v-for="(talg, ids) in ele.ymsPlatformAccountData" :key="ids" :value="talg.ymsPlatformAccountId">{{ talg.code }}</Option>
              </Select>
            </div>
            <!--平台商品SKU-->
            <div class="flex align-items-center" style="position: relative;" :class="(ele.platformItemSku && ele.identicalYmsSkuAlias) ||
             (ele.platformItemSku && ele.existingYmsSku && !ele.identicalYmsSkuAlias) ? 'ivu-form-item-error' : ''">
              <span>{{ $t('key1005750') }}</span>
              <Input :placeholder="$t('key1005747')" clearable v-model.trim="ele.platformItemSku" style="width: 200px;" @on-focus="focusChange"></Input>
              <span class="tips_item_box" v-if="ele.platformItemSku && ele.identicalYmsSkuAlias">{{ $t('key1005751') }}</span>
              <span class="tips_item_box" v-if="ele.platformItemSku && ele.existingYmsSku && !ele.identicalYmsSkuAlias">
              {{ $t('key1005748') + configCharacters(false) + 'SKU' + ' “ ' + ele.existingYmsSku + ' ” ' + $t('key1005749') }}
            </span>
            </div>
            <Icon type="ios-trash-outline" size="22" color="#FD5425" v-if="idx !==item.relatedRelationshipsList.length -1"
              class="ml5 mr24 cursor" @click="deleteRelatedRelationshipsBtn(index, idx)"/>
            <Icon type="md-add-circle" size="22" color="#FD5425" v-else
              class="ml5 cursor" @click="addARelatedRelationshipsBtn(index)"/>
          </div>
        </div>
      </div>
    </div>
    <p class="color-666 mt20">
      {{ $t('key1000615') }}<br/>
      {{ platformTip }}
    </p>
    <template #footer>
      <Button @click="setAssociationRelationshipModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="setAssociationRelationshipBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'setAssociationRelationshipModal',
  mixins: [Mixin],
  data() {
    return {
      setAssociationRelationshipModal: false,
      setAssociationRelationshipData: [],
      platformList: [],
      detailsData: {},
    };
  },
  computed: {
    platformTip() {
      const name = this.configCharacters();
      return `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005739')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005740')}
              ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005741')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005742')}
              ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005743')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005744')}
              ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005745')}
              ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005746')}`;
    }
  },
  methods: {
    // 初始化数据
    initSetAssociationRelationshipData(ymsProductGoodsIdList) {
      let v = this;
      v.getPlatformNameData();
      let platformIdList = [];
      if (ymsProductGoodsIdList.length > 0) {
        v.axios.post(api.post_ymsDistributorProductInfo_queryByYmsProductGoodsIds, ymsProductGoodsIdList, {loading: true}).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas || [];
            if (data.length > 0) {
              v.detailsData = data[0];
              let ymsProductGoodsList = v.detailsData.ymsProductGoodsList || [];
              ymsProductGoodsList.map((item) => {
                let productGoodsSpecifications = item.productGoodsSpecificationList || [];
                item.specifications = productGoodsSpecifications.map(i => i.value).join(' • ') || '';
                let ymsProductGoodsPlatformMappingList = item.ymsProductGoodsPlatformMappingList || [];
                item.relatedRelationshipsList = item.ymsProductGoodsPlatformMappingList || [{platformId: null, ymsPlatformAccountId: null, ymsPlatformAccountData: [], platformItemSku: ''}];
                if (ymsProductGoodsPlatformMappingList.length > 0) {
                  ymsProductGoodsPlatformMappingList.map((ele) => {
                    ele.ymsPlatformAccountData = [];
                    if (ele.platformId) {
                      platformIdList.push(ele.platformId);
                    }
                  });
                }
              });
              if (platformIdList.length > 0) {
                handleFun(ymsProductGoodsList, platformIdList).then((newList) => {
                  v.setAssociationRelationshipData = newList;
                });
                v.$forceUpdate();
              } else {
                v.setAssociationRelationshipData = ymsProductGoodsList;
              }

              // 处理店铺回显数据
              function handleFun(list, platformIdList) {
                return new Promise((resolve) => {
                  let query = {
                    code: '',
                    platformIds: platformIdList
                  };
                  v.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountList, query).then(response => {
                    if (response.data.code === 0) {
                      let data = response.data.datas || [];
                      if (data.length > 0) {
                        let newData = v.handerGrouping(data, function (item) {
                          return [item.platformId];
                        }, 'platformId', 'ymsPlatformAccountData');
                        list.map((item) => {
                          item.relatedRelationshipsList.map((ele) => {
                            newData.map((talg) => {
                              if (ele.platformId === talg.platformId) {
                                ele.ymsPlatformAccountData = talg.ymsPlatformAccountData;
                              }
                            });
                          });
                        });
                      }
                      resolve(list);
                    }
                  });
                });
              }
            }
          }
        });
      }
      this.setAssociationRelationshipModal = true;
    },
    // 获取所有平台
    getPlatformNameData() {
      let v = this;
      v.axios.get(api.get_ymsPlatformOrder_queryPlatformName + '?platformType=sales').then(response => {
        if (response.data.code === 0) {
          v.platformList = response.data.datas || [];
        }
      });
    },
    // 获取指定平台下的所有店铺数据
    getPlatformStoreData(index, idx, platformId) {
      let v = this;
      let query = {
        code: '',
        platformIds: [platformId]
      };
      v.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountList, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          v.setAssociationRelationshipData[index].relatedRelationshipsList[idx].ymsPlatformAccountData = data;
          v.$forceUpdate();
        }
      });
    },
    // 删除
    deleteRelatedRelationshipsBtn(index, idx) {
      this.setAssociationRelationshipData[index].relatedRelationshipsList.splice(idx, 1);
      this.$forceUpdate();
    },
    // 新增
    addARelatedRelationshipsBtn(index) {
      this.setAssociationRelationshipData[index].relatedRelationshipsList.push({
        platformId: null,
        ymsPlatformAccountId: null,
        ymsPlatformAccountData: [],
        platformItemSku: null
      });
      this.$forceUpdate();
    },
    // 确定
    setAssociationRelationshipBtn() {
      let list = [];
      if (this.setAssociationRelationshipData.length > 0) {
        for (const item of this.setAssociationRelationshipData) {
          for (const ele of item.relatedRelationshipsList) {
            if (ele.platformId && ele.ymsPlatformAccountId && ele.platformItemSku) {
              list.push({
                platformId: ele.platformId,
                ymsPlatformAccountId: ele.ymsPlatformAccountId,
                ymsProductGoodsId: item.ymsProductGoodsId,
                platformItemSku: ele.platformItemSku,
                ymsProductId: item.ymsProductId,
                ymsSku: item.ymsSku
              });
            }
          }
        }
        if (list.length > 0) {
          this.axios.post(api.post_ymsProductGoodsPlatformMapping_saveRelation, list, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((res) => {
            if (res.data.code === 0) {
              let data = res.data.datas || [];
              if (data.length > 0) {
                this.setAssociationRelationshipData.map((item) => {
                  item.relatedRelationshipsList.map((ele) => {
                    ele.identicalYmsSkuAlias = false;
                    ele.existingYmsSku = null;
                    data.map((talg) => {
                      if (talg.ymsSkuDb) {
                        if (talg.platformItemSku === ele.platformItemSku) {
                          ele.existingYmsSku = talg.ymsSkuDb;
                        }
                      } else {
                        if (talg.platformId === ele.platformId && talg.ymsPlatformAccountId === ele.ymsPlatformAccountId) {
                          if (talg.platformItemSku === ele.platformItemSku) {
                            ele.identicalYmsSkuAlias = true;
                          }
                        }
                      }
                    });
                  });
                });
                this.$forceUpdate();
              } else {
                this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
                this.setAssociationRelationshipModal = false;
              }
            }
          });
        }
      }
    },
    // 监听弹窗
    setAssociationRelationshipChange(value) {
      if (!value) {
        this.detailsData = {};
        this.setAssociationRelationshipData = [];
      }
    },
    // 获取焦点时，清空所有校验提示
    focusChange() {
      for (const item of this.setAssociationRelationshipData) {
        for (const ele of item.relatedRelationshipsList) {
          ele.identicalYmsSkuAlias = false;
          ele.existingYmsSku = null;
        }
      }
      this.$forceUpdate();
    },
  }
};
</script>

<style lang="less" scoped>
.alias_item_box {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .tips_item_box {
    font-size: 12px;
    color: #ed4014;
    position: absolute;
    top: 35px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    text-align: center;
  }
}
</style>
